import { StarsButton as Button } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Confirm, TXTWCL_Cancel } from './ConfirmButton.messages.json';
import styles from './ConfirmButton.scss';

interface Props {
  onCancel?: () => void;
  onConfirm?: () => void;
}

const ConfirmButton: React.FC<Props> = ({ onCancel, onConfirm }) => (
  <div className={styles.wrap}>
    <Button variant="secondary" translation={TXTWCL_Cancel} size="small" onClick={onCancel} />
    <Button variant="primary" translation={TXTCLI_Confirm} size="small" onClick={onConfirm} />
  </div>
);

export default ConfirmButton;
